module.exports = __webpack_public_path__ + "8dfac87b6c3439e85a552cc61c2ada06.png";